module.exports = __webpack_public_path__ + "static/img/goods2.0d21cea6.png";